module.exports = __webpack_public_path__ + "img/chr_ts_25_penlight.64be5637.png";